/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { TabFormV2 } from '../../../components/v2';
import * as selectorsNsirs from '../../../store/nsir/reducer';
import * as actionsNsirs from '../../../store/nsir/actions';
import * as selectorsNsmp from '../../../store/nsmp/reducer';
import * as actionsNsmp from '../../../store/nsmp/actions';
import * as actionsParseRfg from '../../../store/parseRfg/actions';
import InformacaoBasicaTab from './InformacaoBasicaTab';
import FinanceiroTab from './FinanceiroTab';
import AuditTab from './AuditTab';
import ServicesTab from './ServicesTab';
import MtBtServicesTab from './mtbt/MtBtServicesTab';
import UsoMutuoServiceTab from './UsoMutuoServiceTab';
import DocumentosTab from './DocumentosTab';
import ContextBar from './ContextBar';
import * as Roles from '../../../constants/role';
import * as selectorsAuth from '../../../store/auth/reducer';
import { isUsoMutuo, isUsuarioUsoMuto, isInspecaoMtBt } from 'utils';
import {
  getNsmpIdFromSearch,
  NSIR_SERVICOS_TAB_INDEX,
} from './utils/nsmpUrl';

const NsirV2 = ({
  match,
  history,
  location,
  loadNsirById,
  nsirSelected,
  saveNsir,
  updateNsir,
  nsmps,
  cleanNsmps,
  cleanParseRfg,
  authData,
}) => {
  const [id, setId] = useState(null);
  const [nsirData, setNsirData] = useState({});
  const [nsmpList, setNsmpList] = useState([]);
  const [headerFields, setHeaderFields] = useState({ codigo: '', equipamento: '' });
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    setNsirData({});
    setNsmpList([]);
    setHeaderFields({ codigo: '', equipamento: '' });
    cleanNsmps();
  }, [cleanNsmps]);

  useEffect(() => {
    cleanParseRfg();
    return () => {
      cleanParseRfg();
    };
  }, [id, cleanParseRfg]);

  useEffect(() => {
    if (match && match.params && match.params.nsirId) {
      setId(match.params.nsirId);
    }
  }, [match]);

  useEffect(() => {
    if (id) loadNsirById(id);
  }, [id, loadNsirById]);

  useEffect(() => {
    setNsirData(nsirSelected);
    setNsmpList(nsirSelected.nsmps);
    const codigo = nsirSelected.codigo || '';
    const equipamento = nsirSelected.equipamento || '';
    setHeaderFields((prev) => {
      if (prev.codigo === codigo && prev.equipamento === equipamento) {
        return prev;
      }
      return { codigo, equipamento };
    });
  }, [nsirSelected]);

  useEffect(() => {
    setNsmpList(nsmps);
  }, [nsmps]);

  useEffect(() => {
    if (getNsmpIdFromSearch(location.search)) {
      setActiveTab(NSIR_SERVICOS_TAB_INDEX);
    }
  }, [location.search]);

  const onSaveNsir = (nsir) => {
    if (nsir && nsir.id) {
      updateNsir(nsir);
    } else if (nsir) {
      saveNsir(nsir, (newId) => { history.push(`/v2/nsir/${newId}`); });
    }
  };

  const getTitle = () => {
    const codigo = (headerFields.codigo || '').trim();
    if (codigo) return `NSIR ${codigo}`;
    const equipamento = (headerFields.equipamento || '').trim();
    if (equipamento) return `NSIR - Equipamento ${equipamento}`;
    return 'Nova NSIR';
  };

  const handleHeaderFieldsChange = useCallback((fields) => {
    const codigo = fields.codigo || '';
    const equipamento = fields.equipamento || '';
    setHeaderFields((prev) => {
      if (prev.codigo === codigo && prev.equipamento === equipamento) {
        return prev;
      }
      return { codigo, equipamento };
    });
  }, []);

  const isAdmin = () =>
    authData && (authData.role === Roles.ADMIN || authData.role === Roles.SUPER_ADMIN);

  const getTabs = () => {
    let tabs = [
      {
        element: (
          <InformacaoBasicaTab
            nsir={nsirData}
            onSave={onSaveNsir}
            onHeaderFieldsChange={handleHeaderFieldsChange}
          />
        ),
        label: 'Nsir',
        disabled: false,
      },
    ];

    if (isUsoMutuo(nsirData.tipoServicoId) && !!nsirData.newFlow) {
      tabs = [
        ...tabs,
        {
          element: (
            <UsoMutuoServiceTab
              nsirTitle={getTitle()}
              nsmps={nsmpList}
              nsirStatus={nsirData.status}
              nsirId={nsirData.id}
              inspetorId={nsirData.inspetorId}
              digitadorId={nsirData.digitadorId}
              nsirData={nsirData}
              isUsoMutuo={isUsoMutuo(nsirData.tipoServicoId)}
              history={history}
              location={location}
            />
          ),
          label: 'Serviços',
          disabled: !nsirData || !nsirData.id,
        },
      ];
    } else if (isInspecaoMtBt(nsirData.tipoServicoId)) {
      tabs = [
        ...tabs,
        {
          element: (
            <MtBtServicesTab
              nsirTitle={getTitle()}
              nsmps={nsmpList}
              nsirStatus={nsirData.status}
              nsirId={nsirData.id}
              inspetorId={nsirData.inspetorId}
              digitadorId={nsirData.digitadorId}
              tipoServicoId={nsirData.tipoServicoId}
              nsirData={nsirData}
              history={history}
              location={location}
            />
          ),
          label: 'Serviços',
          disabled: !nsirData || !nsirData.id,
        },
      ];
    } else {
      tabs = [
        ...tabs,
        {
          element: (
            <ServicesTab
              nsirTitle={getTitle()}
              nsmps={nsmpList}
              nsirStatus={nsirData.status}
              nsirId={nsirData.id}
              inspetorId={nsirData.inspetorId}
              digitadorId={nsirData.digitadorId}
              tipoServicoId={nsirData.tipoServicoId}
              newFlow={nsirData.newFlow}
              history={history}
              location={location}
            />
          ),
          label: 'Serviços',
          disabled: !nsirData || !nsirData.id,
        },
      ];
    }

    if (!isUsuarioUsoMuto(authData.email)) {
      tabs = [
        ...tabs,
        {
          element: <FinanceiroTab nsirTitle={getTitle()} nsir={nsirData} isAdmin={isAdmin()} />,
          label: 'Financeiro',
          disabled: !nsirData || !nsirData.id || !isAdmin(),
        },
        {
          element: <DocumentosTab nsirTitle={getTitle()} />,
          label: 'Documentos',
          disabled: !nsirData || !nsirData.id,
        },
        {
          element: (
            <AuditTab nsirId={nsirData.id} />
          ),
          label: 'Auditoria',
          disabled: !nsirData || !nsirData.id || !isAdmin(),
        },
      ];
    }

    return tabs;
  };

  return (
    <Box>
      <Stack spacing={2}>
        <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ pr: 1 }}>
          <Tooltip title="Voltar para lista">
            <IconButton
              size="small"
              onClick={() => history.push('/v2/nsirs')}
              aria-label="Voltar para lista"
              sx={{ mt: 0.25, color: 'text.secondary' }}
            >
              <ArrowBackIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </Tooltip>
          <ContextBar
            nsirData={nsirData}
            codigo={headerFields.codigo}
            equipamento={headerFields.equipamento}
          />
        </Stack>

        <TabFormV2
          tabPanels={getTabs()}
          currentTab={activeTab}
          onChangeTab={setActiveTab}
        />
      </Stack>
    </Box>
  );
};

NsirV2.propTypes = {
  match: PropTypes.object.isRequired,
  saveNsir: PropTypes.func.isRequired,
  updateNsir: PropTypes.func.isRequired,
  loadNsirById: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  nsirSelected: PropTypes.object.isRequired,
  nsmps: PropTypes.array.isRequired,
  cleanNsmps: PropTypes.func.isRequired,
  cleanParseRfg: PropTypes.func.isRequired,
  authData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  nsirSelected: selectorsNsirs.getNsirSelected(state),
  nsmps: selectorsNsmp.getNsmps(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actionsNsirs,
      ...actionsNsmp,
      ...actionsParseRfg,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(NsirV2));
